import type Lenis from 'lenis'
import Alpine from 'alpinejs'
import { useElementSize } from '~/scripts/composables/useElementSize'
import setScrollbarWidth from '~/scripts/tailwindcss/plugins/set-scrollbar-width'
import { setRootCSSVariable } from '~/scripts/utils/css'

const ui = {
  init() {
    if (window.lenis) {
      window.lenis.on('scroll', (lenis: Lenis) => {
        this.scrollY = lenis.scroll
      })
    }
    else {
      console.warn('Lenis is not instantiated so everything that uses $store.ui.scrollY won\'t work as expected.')
    }

    // Effect of scrollLockedBy
    Alpine.effect(() => {
      const locked = this.scrollLockedBy.length > 0

      if (window.lenis) {
        window.lenis[locked ? 'stop' : 'start']()
      }
      else {
        const html = document.documentElement
        html.classList[locked ? 'add' : 'remove']('lock-scroll')
      }
    })

    // Observe WP Toolbar height
    const wpAdminBar = document.querySelector<HTMLElement>('#wpadminbar')
    if (wpAdminBar) {
      useElementSize(wpAdminBar, (size) => {
        this.wpAdminBarHeight = size.height
      })
    }

    // Observe WP Toolbar fixed
    const wpAdminBarFixedMediaQuery = window.matchMedia('(min-width: 601px)')
    this.wpAdminBarFixed = wpAdminBarFixedMediaQuery.matches
    wpAdminBarFixedMediaQuery.addEventListener('change', (event) => {
      this.wpAdminBarFixed = event.matches
    })

    setTimeout(() => {
      this.scrollY = window.scrollY
    }, 100)

    // Sync state with CSS variables
    Alpine.effect(() => {
      setRootCSSVariable('header-height', `${this.headerHeight}px`)
    })

    Alpine.effect(() => {
      setRootCSSVariable('wp-admin-bar-height', `${this.wpAdminBarHeight}px`)
    })

    Alpine.effect(() => {
      setRootCSSVariable('wp-admin-bar-fixed', this.wpAdminBarFixed ? '1' : '0')
    })

    Alpine.effect(() => {
      setRootCSSVariable('menu-offset-top', `${this.menuOffsetTop}px`)
    })

    Alpine.effect(() => {
      setRootCSSVariable('offset-top', `${this.offsetTop}px`)
      setRootCSSVariable('scroll-padding-top', `${this.scrollPaddingTop}px`)
    })
  },

  // Scroll
  scrollY: 0,
  get scrolled() {
    return this.scrollY >= 10
  },

  // Lock scroll
  scrollLockedBy: [] as string[],
  lockScrollBy(key: string) {
    this.scrollLockedBy.push(key)
    setTimeout(() => {
      setScrollbarWidth()
    }, 100)
  },
  unlockScrollBy(key: string) {
    this.scrollLockedBy = this.scrollLockedBy.filter(item => item !== key)
    setTimeout(() => {
      setScrollbarWidth()
    }, 100)
  },

  // Header
  headerHeight: 0,
  wpAdminBarFixed: false,
  wpAdminBarHeight: 0,
  menuOffsetTop: 0,

  // Offsets
  get offsetTop() {
    return this.headerHeight + (this.wpAdminBarFixed ? this.wpAdminBarHeight : 0)
  },
  get scrollPaddingTop() {
    return this.offsetTop + 100
  },
}

// Declare uiStore as an Alpine store module
declare module 'alpinejs' {
  interface Stores {
    ui: typeof ui
  }
}

export default ui
